var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAk2712127430(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200.5 30",
    style: {
      enableBackground: "new 0 0 200.5 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 126.5,
    y: -6.2,
    transform: "matrix(0.4706 -0.8824 0.8824 0.4706 60.3253 116.2395)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.2,
    y: 20.9,
    transform: "matrix(0.8672 -0.498 0.498 0.8672 6.2177 66.2185)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139,
    y: 11.2,
    width: 3.5,
    height: 7.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.4,30h-29.8V0.4h29.8V30z M114.8,28.9h27.5V1.5h-27.5V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,26h-22.5V4H140V26z M118.7,24.8h20.2V5.1h-20.2V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.8,
    y: -6.2,
    transform: "matrix(0.4706 -0.8824 0.8824 0.4706 0.1711 15.984)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.4,
    y: 20.9,
    transform: "matrix(0.8672 -0.498 0.498 0.8672 -8.8767 9.6283)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.4,
    y: 11.2,
    width: 3.5,
    height: 7.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7,30H0V0.4h29.7V30z M1.1,28.9h27.5V1.5H1.1V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4,26H3.9V4h22.5V26z M5,24.8h20.2V5.1H5V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.1,
    y: 7.3,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 18.3123 88.9658)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.4,
    y: 7.4,
    transform: "matrix(0.4979 -0.8672 0.8672 0.4979 75.2501 172.8807)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.6,
    y: 11.2,
    width: 3.5,
    height: 7.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.5,30h-29.8V0.4h29.8V30z M171.9,28.9h27.5V1.5h-27.5V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.6,26h-22.5V4h22.5V26z M175.3,24.8h20.2V5.1h-20.2V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.2,
    y: -6.2,
    transform: "matrix(0.4706 -0.8824 0.8824 0.4706 15.1673 40.9773)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.9,
    y: 20.9,
    transform: "matrix(0.8672 -0.498 0.498 0.8672 -5.1139 23.7353)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1,30H28.3V0.4h29.8V30z M29.5,28.9h27.5V1.5H29.5V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7,26H32.2V4h22.5V26z M33.4,24.8h20.2V5.1H33.4V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.8,
    y: -6.2,
    transform: "matrix(0.4706 -0.8824 0.8824 0.4706 30.3084 66.2121)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.5,
    y: 20.9,
    transform: "matrix(0.8672 -0.498 0.498 0.8672 -1.314 37.9815)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.3,
    y: 11.2,
    width: 3.5,
    height: 7.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7,30H56.9V0.4h29.7V30z M58.1,28.9h27.5V1.5H58.1V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3,26H60.8V4h22.5V26z M62,24.8h20.2V5.1H62V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.1,
    y: -6.2,
    transform: "matrix(0.4706 -0.8824 0.8824 0.4706 45.3047 91.2054)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.8,
    y: 20.9,
    transform: "matrix(0.8672 -0.498 0.498 0.8672 2.4488 52.0885)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,30H85.3V0.4H115V30z M86.4,28.9h27.5V1.5H86.4V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.6,26H89.2V4h22.5V26z M90.3,24.8h20.2V5.1H90.3V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.5,
    y: 7.3,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 14.9478 75.5047)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.7,
    y: 7.4,
    transform: "matrix(0.4979 -0.8672 0.8672 0.4979 60.8845 148.0682)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.9,30h-29.7V0.4h29.7V30z M143.3,28.9h27.5V1.5h-27.5V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,26h-22.5V4H168V26z M146.7,24.8h20.2V5.1h-20.2V24.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.5,28.5l-0.2,0c-0.3-0.1-0.4-0.5-0.3-0.7l1.8-4.2c0.1-0.3,0.5-0.4,0.7-0.3c0.3,0.1,0.4,0.5,0.3,0.7l-1.8,4.2 C116,28.4,115.8,28.5,115.5,28.5z M118.6,21.1l-0.2,0c-0.3-0.1-0.4-0.5-0.3-0.7l1.8-4.2c0.1-0.3,0.5-0.4,0.7-0.3 c0.3,0.1,0.4,0.5,0.3,0.7l-1.8,4.2C119.1,21,118.8,21.1,118.6,21.1z M121.7,13.8l-0.2,0c-0.3-0.1-0.4-0.5-0.3-0.7l1.8-4.2 c0.1-0.3,0.5-0.4,0.7-0.3c0.3,0.1,0.4,0.5,0.3,0.7l-1.8,4.2C122.1,13.6,121.9,13.8,121.7,13.8z M124.8,6.4l-0.2,0 c-0.3-0.1-0.4-0.5-0.3-0.7l1.8-4.2c0.1-0.3,0.5-0.4,0.7-0.3c0.3,0.1,0.4,0.5,0.3,0.7L125.3,6C125.2,6.3,125,6.4,124.8,6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.9,29.6c-0.2,0-0.4-0.1-0.5-0.3l-2.2-4c-0.2-0.3-0.1-0.6,0.2-0.8c0.3-0.2,0.6-0.1,0.8,0.2l2.2,4 c0.2,0.3,0.1,0.6-0.2,0.8L142.9,29.6z M139,22.7c-0.2,0-0.4-0.1-0.5-0.3l-2.2-4c-0.2-0.3-0.1-0.6,0.2-0.8c0.3-0.2,0.6-0.1,0.8,0.2 l2.2,4c0.2,0.3,0.1,0.6-0.2,0.8L139,22.7z M135.1,15.7c-0.2,0-0.4-0.1-0.5-0.3l-2.2-4c-0.2-0.3-0.1-0.6,0.2-0.8 c0.3-0.2,0.6-0.1,0.8,0.2l2.2,4c0.2,0.3,0.1,0.6-0.2,0.8L135.1,15.7z M131.2,8.7c-0.2,0-0.4-0.1-0.5-0.3l-2.2-4 c-0.2-0.3-0.1-0.6,0.2-0.8c0.3-0.2,0.6-0.1,0.8,0.2l2.2,4c0.2,0.3,0.1,0.6-0.2,0.8L131.2,8.7z M127.3,1.8c-0.2,0-0.4-0.1-0.5-0.3 l-0.4-0.6c-0.2-0.3-0.1-0.6,0.2-0.8c0.3-0.2,0.6-0.1,0.8,0.2l0.4,0.6c0.2,0.3,0.1,0.6-0.2,0.8L127.3,1.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAk2712127430);
export default __webpack_public_path__ + "static/media/AK2_7_1212743_0.71fc236a544778d668c3b9a32a8125ed.svg";
export { ForwardRef as ReactComponent };